import { ComponentProps } from 'react';

import shuffle from 'lodash/shuffle';

import { getOnClickTracking } from '../FeaturedPropertyList/featuredPropertyTracking';
import FeaturedProperties, { internalPromoIds } from '../FeaturedProperties';

import { ListingResponse } from '../Listings/Listings.types';

export type InternalPromoId = typeof internalPromoIds[number];

export type PropertyOrPromoItem = ListingResponse | InternalPromoId;

type FeaturedItems = ComponentProps<typeof FeaturedProperties>['featuredItems'];

export const isProperty = (
    propertyOrPromo: PropertyOrPromoItem
): propertyOrPromo is ListingResponse =>
    (propertyOrPromo as ListingResponse).listingId !== undefined;

export const getFeaturedListingsToDisplay = (properties: ListingResponse[]) => {
    const shuffledPromos = shuffle(internalPromoIds);
    const items = (properties as PropertyOrPromoItem[]).concat(shuffledPromos);

    const maxItems = 3;
    const minProperties = 1;
    return properties.length >= minProperties ? items.slice(0, maxItems) : [];
};

export const getFeaturedItems = (items: PropertyOrPromoItem[]): FeaturedItems =>
    items.map((item, index) =>
        isProperty(item)
            ? {
                  type: 'Featured Property',
                  data: item,
                  onClick: getOnClickTracking(item, index)
              }
            : {
                  type: 'Internal Promo',
                  id: item,
                  onClick: getOnClickTracking(item, index)
              }
    );
